import React from "react";
import { Box } from "@mui/material";
import CategorySkeleton from "../CategorySkeleton";

export default function CategorySkeletonGrid() {
  return (
    <Box
      sx={{
        display: "grid",
        gap: { xs: 1.5, sm: 2 },

        gridTemplateColumns: {
          xs: "repeat(3, 1fr)",
          sm: "repeat(4, 1fr)",
          md: "repeat(6, 1fr)",
        },
      }}
    >
      {Array.from({ length: 8 }).map((_, index) => (
        <CategorySkeleton key={index} />
      ))}
    </Box>
  );
}
